import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isVisible: false, // 上传单曲弹窗
    album_id: "", // 专辑 ID
    is_album: false, // 是否是专辑
    shouldGetMusicList: false, // 新增状态
    areaLoading: false, // 假设 areaLoading 也是你需要映射的状态
    GetMusicList: 1, // 是否获取音乐列表
    GetAlbumValue: false, // 是否获取专辑详情
    SongIndex: null ,// 歌曲索引
    tijiao:false
  },
  getters: {},
  actions: {
    callSiblingMethod({ state }) {
      console.log('兄弟组件的方法被调用了');
      state.isVisible = !state.isVisible;
      console.log(state.isVisible);
      state.shouldGetMusicList = true;
    },
    //外部音乐列表
    getMusicListactions({ state }) {
      console.log('外部音乐列表方法被调用了');
      state.GetMusicList = state.GetMusicList + 1;
    },
    //专辑详情
    getAlbumDetailactions({ state }) {
      console.log('专辑详情方法被调用了');
      state.GetAlbumValue = true;
    },
    updataAlbumDetailactions({ state }) {
      console.log('修改专辑详情了');
      state.GetAlbumValue = false;
    },
    tijiaoSongactions({ state }) {
      console.log('提交歌曲信息');
    state.tijiao = true;
    },


  },
  mutations: {
    setVisibility(state, isVisible) {
      state.isVisible = isVisible;
    },
    setAlbumId(state, album_id) {
      state.album_id = album_id;
    },
    setShouldGetMusicList(state, value) {
      state.shouldGetMusicList = value;
    },
    settijiao(state, value) {
      state.tijiao = value;
    },
    setAreaLoading(state, value) {
      state.areaLoading = value;
    },
    //修改歌曲索引
    updataSongIndex(state, index) {
      state.SongIndex = index;
      console.log(state.SongIndex, '歌曲索引');
    }
  },
  modules: {}
});